import React, { useContext } from 'react'
import { NavLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import { ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../Context/ConfigContext';
import Config from '../appConfig';

const Footer = () => {
  const { t } = useTranslation();
  const dir = localStorage.getItem('dir');

  const { currency } = useContext(ConfigContext);

  return (
    <footer className="footer darkColor" style={{ textAlign: window.innerWidth <= 768 ? 'center' : '', marginBottom: 0 }}>
      <ToastContainer position="bottom-right" hideProgressBar />
      <div className="footer-middle" dir={dir} style={window.innerWidth <= 768 ? { textAlign: 'center' } : { textAlign: dir === 'rtl' ? 'right' : 'left' }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-sm-6">
              <div className="widget">
                <h4 className="widget-title">{t('contact_info')}</h4>
                <ul className="contact-info">
                  <li>
                    <span className="contact-info-label">{('Ghayar')}{('E-Commerce')}</span>
                    {/* {('FooterPara1')} */}
                    {t('short_about_us_text')}
                  </li>
                  <div className="row mb-0">
                    <li className="col-md-6">
                      <span className="contact-info-label">{t('phone')}</span>
                      <NavLink to="tel:">
                        {('+971800442522')}
                      </NavLink>
                    </li>
                    <li className="col-md-6">
                      <span className="contact-info-label">{t('email')}</span>
                      <NavLink to="mailto:business@ghayar.com">
                        <span className="__cf_email__">business@ghayar.com</span>
                      </NavLink>
                    </li>
                  </div>
                  <div className="row">
                    <li className="col-md-12">
                      <NavLink to={`/Contact`}><span className="contact-info-label">{t('our_location')}</span> </NavLink>
                      <p>
                        Ajman, AL Rawda 1, Algeria St, Al Meera Building, M002,
                        Warehouse No. 3 - Umm Dera - New Industrial Area - Emirate of Umm Al Quwain
                      </p>
                    </li>
                    <li className="col-md-6">
                      <span className="contact-info-label">{t('working_hours')}</span> {('8:30 AM - 6:00 PM')}
                    </li>
                  </div>
                </ul>
                <div className="social-icons" style={window.innerWidth <= 768 ? { display: 'flex', justifyContent: 'center' } : {}}>
                  <NavLink to={`https://www.facebook.com/ghayar.ae%20target=`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                    <FacebookIcon />
                  </NavLink>
                  <NavLink to={`https://www.youtube.com/@ghayarautospareparts8352`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                    <YouTubeIcon />
                  </NavLink>
                  <NavLink to={`https://www.instagram.com/ghayar.ae`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                    <InstagramIcon />
                  </NavLink>
                  <NavLink to={`https://bit.ly/2xPA8kY`} className="social-icon social-youtube icon-youtube" target="_blank" rel="noreferrer" title="Twitter">
                    <XIcon />
                  </NavLink>

                </div>
                {/* End .social-icons */}
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
            <div className="col-lg-3 col-sm-6">
              <div className="widget">
                <h4 className="widget-title">{t("customer_service")}</h4>
                <ul className="links">
                  <li>
                    <NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Faqs`}>{t("help_and_faqs")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Privacy-Policy`}>{t('privacy')}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Delivery`}>{t("delivery_shipment")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Cancelation`}>{t("cancelation_return")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Warranty-Coverage`}>{t("warranty_coverage")}</NavLink></li>
                  {currency.toLowerCase() !== "usd" && <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/RewardsPolicy`}>{t("Rewards Policy")}</NavLink></li>}
                </ul>
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
            <div className="col-lg-2 col-sm-6">
              <div className="widget">
                <h4 className="widget-title">{t("for_users")}</h4>
                <ul>

                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Signup`}>{t("login")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Signup`}>{t('create_account')}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={localStorage.getItem("business_id") ? `/MyAccount` : `/Signup`}>{t("my_account")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={localStorage.getItem("business_id") ? `/MyAccount/Orders` : `/Signup`}>{t("my_orders")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={localStorage.getItem("business_id") ? `/MyAccount/AccountDetails` : `/Signup`}>{t("profile")}</NavLink></li>
                </ul>

              </div>
              {/* End .widget */}
            </div>
            <div className="col-lg-2 col-sm-6" >
              <div className="widget">
                <h4 className="widget-title">{t("about_us")}</h4>
                <ul>

                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Aboutus`}>{t("company_info")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Easy-way-to-Shop`}>{t('easy_way_to_shop')}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Safe-Shopping`}>{t("safe_shopping")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Suppliers`}>{t("car_parts_online")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Attractive-Prices`}>{t("attractive_price")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Brands`}>{t("brands")}</NavLink></li>
                  <li><NavLink onClick={() => { window.scrollTo(0, 0); }} to={`/Careers`}>{t("careers")}</NavLink></li>
                </ul>

              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
            <div className="col-lg-2 col-sm-6" style={{ display: 'none' }}>
              <h4 className="widget-title">{t("our_app")}</h4>
              <div className="widget widget-newsletter" style={window.innerWidth <= 768 ? { textAlign: 'center', display: 'flex', justifyContent: 'center' } : {}}>

                <ul>
                  <li style={{ paddingBottom: '15px' }}>
                    <img src="assets/images/Files/Our_Apps/apple-store.png" alt={"AppleStore"} />
                  </li>
                  <li>
                    <img src="assets/images/Files/Our_Apps/google-play.png" alt={"GoogleStore"} />
                  </li>
                </ul>
              </div>
              {/* End .widget */}
            </div>
            {/* End .col-lg-2.5 */}
          </div>
          {/* End .row */}
        </div>
        {/* End .container */}
      </div>



      <div className="container footer-copyright-notice">
        <div className="copyright-box">
          <div className="copyright-badge">
            <i className="fas fa-folder"></i>
            <span>Ghayar Inside</span>
          </div>

          <div className="copyright-text">
            <p>
              <strong>
                The data displayed here, especially the entire database, may not be
                copied.
              </strong>
              <br />
              Reproducing and distributing the data and the database without prior
              consent from <strong>Ghayar</strong> and/or engaging third parties in
              such activities is strictly prohibited. Any unauthorised use of content
              constitutes copyright infringement and will be subject to legal action.
            </p>
          </div>
        </div>
      </div>

      <style>
        {`
.footer-copyright-notice{
    border-top:1px solid rgba(255,255,255,.15);
    margin-top:25px;
    padding:20px 0;
}

.copyright-box{
    display:flex;
    align-items:flex-start;
    gap:22px;
}

.copyright-badge{
    width:200px;
    min-width:200px;
    height:58px;
    border:1px solid rgba(255,255,255,.35);
    border-radius:4px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:10px;
    background:transparent;
    color:#fff;
    flex-shrink:0;
}

.copyright-badge i{
    font-size:22px;
    color:#fff;
}

.copyright-badge span{
    font-size:22px;
    font-weight:700;
    color:#fff;
    white-space:nowrap;
    line-height:1;
}

.copyright-text{
    flex:1;
    max-width:980px;
}

.copyright-text p{
    margin:0;
    color:#d8d8d8;
    font-size:15px;
    line-height:1.55;
    font-weight:400;
    text-align:left;
}

.copyright-text strong{
    color:#ffffff;
    font-size:16px;
    font-weight:700;
}

@media (max-width:991px){

    .copyright-box{
        gap:16px;
    }

    .copyright-badge{
        width:180px;
        min-width:180px;
        height:54px;
    }

    .copyright-badge span{
        font-size:20px;
    }

    .copyright-text p{
        font-size:14px;
    }

    .copyright-text strong{
        font-size:15px;
    }
}

@media (max-width:768px){

    .footer-copyright-notice{
        padding:18px 10px;
    }

    .copyright-box{
        flex-direction:column;
        align-items:center;
        gap:15px;
    }

    .copyright-badge{
        width:230px;
        min-width:230px;
        height:56px;
    }

    .copyright-badge span{
        font-size:21px;
    }

    .copyright-text{
        max-width:100%;
    }

    .copyright-text p{
        text-align:center;
        font-size:13px;
        line-height:1.7;
    }

    .copyright-text strong{
        font-size:14px;
    }
}
`}
      </style>


      <div className="container">
        <div className="footer-bottom">
          <div className="container d-sm-flex align-items-center">
            <div className="footer-left">
              <span className="footer-copyright">&copy;Ghayar LLC all rights reserved</span>
            </div>
            <img
              src={`${Config.country === "uae" ? '/assets/icons/GhayarTruck.png' : "/assets/icons/ksa_ghayar_truck.png"}`}
              alt='GhayarTruck'
              style={{
                height: '30px',
                marginLeft: '10px',
                display: window.innerWidth <= 768 ? 'none' : '',
                float: 'right',
                position: 'absolute',
                right: 10
              }}
            />
          </div>
        </div>
        {/* End .footer-bottom */}
      </div>
      {/* End .container */}
    </footer>
  );
}

export default Footer;